(function () {
  document.querySelectorAll('[id^="sbc-"]').forEach(function (section) {
    var track = section.querySelector('.sbc-track');
    if (!track) return;

    var total = parseInt(track.dataset.total, 10);
    if (!total || total === 0) return;

    var duration   = parseInt(track.dataset.duration, 10) || 400;
    var autoplayOn = track.dataset.autoplay === 'true';
    var autoplayMs = parseInt(track.dataset.autoplaySpeed, 10) || 3000;

    var prevBtn = section.querySelector('.sbc-arrow-prev');
    var nextBtn = section.querySelector('.sbc-arrow-next');
    var dots    = Array.from(section.querySelectorAll('.sbc-dot'));

    var currentIndex    = 0;
    var virtualIndex    = 0;
    var isTransitioning = false;
    var autoplayTimer   = null;
    var safetyTimer     = null;

    /* ── helpers ── */

    function getStep() {
      var card = track.querySelector('.sbc-card');
      if (!card) return 200;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function setX(x, animate) {
      track.style.transition = animate ? ('transform ' + duration + 'ms ease') : 'none';
      track.style.transform  = 'translateX(' + x + 'px)';
    }

    function positionFor(virtualIdx) {
      return -(total + virtualIdx) * getStep();
    }

    function jumpTo(index, animate) {
      virtualIndex = index;
      currentIndex = index;
      setX(positionFor(index), animate);
    }

    function updateDots(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('sbc-dot-active', i === index);
      });
    }

    function clearSafety() {
      if (safetyTimer) {
        clearTimeout(safetyTimer);
        safetyTimer = null;
      }
    }

    /* ── snap after animation ── */

    function snapIfNeeded() {
      clearSafety();

      var realIdx;
      if (virtualIndex < 0) {
        realIdx = virtualIndex + total;
      } else if (virtualIndex >= total) {
        realIdx = virtualIndex - total;
      } else {
        realIdx = virtualIndex;
      }

      // Only snap if we drifted off the real range (we're on a clone)
      if (virtualIndex !== realIdx) {
        virtualIndex = realIdx;
        setX(positionFor(realIdx), false);
        // force reflow so the next transition restarts cleanly
        void track.offsetLeft;
      }

      currentIndex = realIdx;
      isTransitioning = false;
    }

    /* ── init ── */

    jumpTo(0, false);
    void track.offsetLeft;
    requestAnimationFrame(function () {
      track.classList.add('sbc-ready');
    });

    /* ── nav ── */

    function next() {
      if (isTransitioning) return;
      isTransitioning = true;

      virtualIndex = currentIndex + 1;
      var displayIdx = virtualIndex >= total ? 0 : virtualIndex;

      setX(positionFor(virtualIndex), true);
      updateDots(displayIdx);

      // safety net: if transitionend never fires, force-snap after duration + buffer
      clearSafety();
      safetyTimer = setTimeout(snapIfNeeded, duration + 80);
    }

    function prev() {
      if (isTransitioning) return;
      isTransitioning = true;

      virtualIndex = currentIndex - 1;
      var displayIdx = virtualIndex < 0 ? total - 1 : virtualIndex;

      setX(positionFor(virtualIndex), true);
      updateDots(displayIdx);

      clearSafety();
      safetyTimer = setTimeout(snapIfNeeded, duration + 80);
    }

    /* ── transitionend: silent snap when on a clone ── */

    track.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'transform') return;
      if (!isTransitioning) return;
      snapIfNeeded();
    });

    /* ── button clicks ── */

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); resetAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); resetAutoplay(); });

    /* ── dot clicks ── */

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        if (isTransitioning) return;
        if (i === currentIndex) return;
        isTransitioning = true;
        virtualIndex = i;
        currentIndex = i;
        setX(positionFor(i), true);
        updateDots(i);
        clearSafety();
        safetyTimer = setTimeout(snapIfNeeded, duration + 80);
        resetAutoplay();
      });
    });

    /* ── resize ── */

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        isTransitioning = false;
        clearSafety();
        jumpTo(currentIndex, false);
      }, 120);
    });

    /* ── touch / swipe ── */

    var touchX = 0, touchY = 0;

    section.addEventListener('touchstart', function (e) {
      touchX = e.touches[0].clientX;
      touchY = e.touches[0].clientY;
    }, { passive: true });

    section.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchX;
      var dy = e.changedTouches[0].clientY - touchY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        dx < 0 ? next() : prev();
        resetAutoplay();
      }
    }, { passive: true });

    /* ── autoplay ── */

    function startAutoplay() {
      if (!autoplayOn) return;
      if (autoplayTimer) return;
      autoplayTimer = setInterval(function () {
        // self-heal: if something got stuck, recover
        if (isTransitioning) {
          snapIfNeeded();
        }
        next();
      }, autoplayMs);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function resetAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    startAutoplay();

    /* ── pause on hover (desktop) ── */

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    /* ── pause when tab hidden, resume when visible ── */

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        isTransitioning = false;
        clearSafety();
        jumpTo(currentIndex, false);
        startAutoplay();
      }
    });

    /* ── bfcache restore ── */

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        isTransitioning = false;
        clearSafety();
        jumpTo(currentIndex, false);
        resetAutoplay();
      }
    });
  });
})();